import React, { useState, useEffect} from 'react'
import { LinkContainer } from 'react-router-bootstrap'
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import 'react-bootstrap/Button';
import CustomSearch from '../CustomSearch'
import { BASE_URL } from '../../utils/constants';
import Badge from 'react-bootstrap/Badge'
import axios from 'axios'
import { canViewAnalysis, canViewSurgeonTasks, canViewPatientCompliance, canViewPatientComplications, getRoleDisplayName, getRoleBadgeColor } from '../../utils/permissions'

import './Header.scss'

const Header = ({ loggedIn, user, logUserOut, numberOfNotifications, setNumberOfNotifications }) => {
  const [patients, setPatients] = useState([])
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const config = {
    headers: {
      Authorization: `Bearer ${user.token}`,
    },
  }

  useEffect(() => {
    const getAllPatients = async () => {
      try {
          const response = await axios.get(`${BASE_URL}/api/v1/patient/search-box`, config)
          setPatients(response.data.patients)
      }
      catch (error) {
        console.log(error)
        const message = error.response && error.response.data.message ? error.response.data.message : error.message
        if (error.response && (error.response.status === 401 || message === 'Not authorized, token failed')) {
          logUserOut()
        }
      }
    }
    if(loggedIn) {
      getAllPatients()
    }
  }, [loggedIn])

 useEffect(() => {
    const getNumberOfNotifications = async () => {
      try {
        let response = await axios.get(`${BASE_URL}/api/v1/self-assessment/outliers?include-archived=false`, config)
        const surveyOutliers = response.data.surveyOutliers
        
        response = await axios.get(`${BASE_URL}/api/v1/self-assessment/terms-and-conditions-rejected/`, config)
        const termsAndConditionsRejectedSurveys = response.data.termsAndConditionsRejectedSurveys
        
        setNumberOfNotifications(surveyOutliers.length + termsAndConditionsRejectedSurveys.length)
      }
      catch (error) {
        console.log(error)
        const message = error.response && error.response.data.message ? error.response.data.message : error.message
        if (error.response && (error.response.status === 401 || message === 'Not authorized, token failed')) {
          logUserOut()
        }
      }
    }
    getNumberOfNotifications()
  }, [])

  const handleOnSelect = (patient) => {
    navigate(`/patients/${patient.custom_id}`)
    setExpanded(false)
  }



  return (
    <header className='header'>
      <Navbar expand="lg" bg="dark" expanded={expanded}>
      <Container fluid="xxl">
        <Navbar.Brand>
          <LinkContainer to='/dashboard'>
                <Nav.Link className='logo'>OTOS</Nav.Link>
          </LinkContainer>
        </Navbar.Brand>
        {loggedIn? (
          <>
          <Navbar.Toggle aria-controls="navbarScroll" onClick={() => setExpanded(expanded ? false : "expanded")}/>
          <Navbar.Collapse id="navbarScroll">
            <Nav className="me-auto my-2 my-lg-0 mx-auto" navbarScroll>
              <LinkContainer to='/dashboard'>
                  <Nav.Link onClick={() => setExpanded(false)}>DASHBOARD</Nav.Link>
              </LinkContainer>
              <LinkContainer to='/patients'>
                  <Nav.Link onClick={() => setExpanded(false)}>PATIENTS</Nav.Link>
              </LinkContainer>
              {canViewAnalysis(user) && (
                <LinkContainer to='/analysis'>
                    <Nav.Link onClick={() => setExpanded(false)}>ANALYSIS</Nav.Link>
                </LinkContainer>
              )}
              <LinkContainer to='/notifications'>
                  <Nav.Link onClick={() => setExpanded(false)}>NOTIFICATIONS {numberOfNotifications > 0 && (<Badge pill bg="danger">{numberOfNotifications}</Badge>)}</Nav.Link>
              </LinkContainer>
              <NavDropdown data-bs-theme="dark" title={user.username.toUpperCase()} id="basic-nav-dropdown">
              <NavDropdown.ItemText>
                <Badge bg={getRoleBadgeColor(user.role)}>{getRoleDisplayName(user.role)}</Badge>
              </NavDropdown.ItemText>
              <NavDropdown.Divider />
              {canViewSurgeonTasks(user) && (
                <LinkContainer to='/surgeon-tasks'>
                  <NavDropdown.Item onClick={() => setExpanded(false)}>Surgeon Tasks</NavDropdown.Item>
                </LinkContainer>
              )}
              {canViewPatientCompliance(user) && (
                <LinkContainer to='/patient-compliance'>
                  <NavDropdown.Item onClick={() => setExpanded(false)}>Patient Compliance</NavDropdown.Item>
                </LinkContainer>
              )}
              {canViewPatientComplications(user) && (
                <LinkContainer to='/patient-complications'>
                  <NavDropdown.Item onClick={() => setExpanded(false)}>Patient Complications</NavDropdown.Item>
                </LinkContainer>
              )}
              {(canViewSurgeonTasks(user) || canViewPatientCompliance(user) || canViewPatientComplications(user)) && <NavDropdown.Divider />}
              <NavDropdown.Item onClick={() => logUserOut()}>Sign Out</NavDropdown.Item>
            </NavDropdown>
            </Nav>
            <div className='search'>
              <CustomSearch
                items={patients}
                onSelect={handleOnSelect}
                placeholder="Search"
              />
            </div>
          </Navbar.Collapse>
          </>
        ) : null
        }
      </Container>
    </Navbar>
    </header>
  );
}


export default Header;
